var Index_banner_slider = new Swiper(".Index_banner_slider", {
    loop: true,
    speed: 1000,
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    // },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
});